import React from "react";
import { css } from "styled-components";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";

const enum fields {
    dividerColor = "dividerColor",
    dividerHeight = "dividerHeight",
    dividerWidth = "dividerWidth",
    marginTop = "marginTop",
    marginBottom = "marginBottom",
    marginLeft = "marginLeft"
}

interface Props extends WidgetProps {
    fields: {
        [fields.dividerColor]: string;
        [fields.dividerHeight]: string;
        [fields.dividerWidth]: string;
        [fields.marginTop]: string;
        [fields.marginBottom]: string;
        [fields.marginLeft]: string;

    }
}

const CustomLineDivider: React.FC<Props> = ({fields}) => {

    const wrapperStyles = {
        css: css`
            margin-top: ${fields.marginTop};
            margin-bottom: ${fields.marginBottom};
            border-top: ${fields.dividerHeight}px solid ${fields.dividerColor};
            width: ${fields.dividerWidth}%;
            margin-left: ${fields.marginLeft};
        `
    }

    const dividerStyles = {
        css: css `
         
        `
    }

    return (
        <StyledWrapper {...wrapperStyles}>
        </StyledWrapper>
    )
}


const widgetModule: WidgetModule = {
    component: CustomLineDivider,
    definition: {
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.dividerColor,
                editorTemplate: "ColorPickerField",
                displayName: "Divider Color",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.dividerHeight,
                editorTemplate: "TextField",
                displayName: "Divider Height (px)",
                defaultValue: "1",
            },
            {
                fieldType: "Translatable",
                name: fields.dividerWidth,
                editorTemplate: "TextField",
                displayName: "Divider Width (%)",
                defaultValue: "100",
            },
            {
                fieldType: "Translatable",
                name: fields.marginTop,
                editorTemplate: "TextField",
                displayName: " Margin Top (%/px/rem)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.marginBottom,
                editorTemplate: "TextField",
                displayName: "Margin Bottom (%/px/rem)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.marginLeft,
                editorTemplate: "TextField",
                displayName: "Margin Left (%/px/rem)",
                defaultValue: "0",
            },
            ],
            group: "Common",
    }
}

export default widgetModule;